import Message from "../Message";
import Renderer from "../Renderer";

/**
 * @creator Stefano
 * @date 1-4-2018
 */
export default class IframeController {
    constructor() {
        this.spreads = new Map();
        this.includedSwipe = [];
        this.isOnline = true;
        this.extra_args = {};
        this.disabledCookies = window.interface_settings?.settings?.cookieConsent || false;
        if (this.disabledCookies && window.MaglrCookieConsented) {
            this.disabledCookies = false;
        }
        if (window?.interface_settings?.url_injects) {
            this.extra_args = window.interface_settings.url_injects;
        }
    }

    resetSpreads() {
        this.spreads = new Map();
        this.includedSwipe = [];
    }

    createSpreadContainer(spread_id) {
        return this.createIframe(spread_id)[0];
    }

    createIframe(spread_id) {
        let iframe = $(`#frame_${spread_id}`);
        if (iframe.length === 0) {
            let element = $("#" + spread_id);
            if (element) {
                Renderer.nativeInject(
                    spread_id,
                    `<iframe data-timestamp="${element.data("timestamp")}" data-spread_id="${spread_id}" allowFullScreen src="" id="frame_${spread_id}" title="${element.data("spreadtitle")}"></iframe>`,
                    { ALLOWED_TAGS: ["iframe"] },
                );
                iframe = element.find("iframe");
            }
        }
        return iframe;
    }
    /**
     * Set the the url based on the parent src that is given in the data-src
     * Only sets the iframe src if we have not yet set a source of the iframe
     *
     * @param {Object} iframe
     * @public
     */
    setUrlIframe(iframe) {
        if (iframe.attr("data-src") === "" || iframe.attr("data-src") === undefined) {
            const id = iframe.attr("id");

            iframe.attr("id", id + "_T" + Date.now()); //hack for iphone change the id
            const src = iframe.parent().data("src");

            const timestamp = iframe.data("timestamp");
            if (window.data_domain && src) {
                const baseUri = window.data_domain;
                const uri =
                    window.exportType === "ipad"
                        ? `${baseUri}${src.replace("index.html", "index_relative.html")}`
                        : `${baseUri}/${src}?time=${timestamp}`;

                if (timestamp !== "") {
                    $(".loader").show();
                }
                iframe.attr("src", uri);
            } else {
                iframe.attr("data-src", src);
                iframe.attr("src", src);
            }
            iframe.attr("id", id);
        }
    }

    createSpread(spread_id) {
        if (!this.spreads.has(spread_id)) {
            spread_id = parseInt(spread_id);
            let iframe = this.createIframe(spread_id);
            this.spreads.set(spread_id, this.getElement(spread_id));
            this.setUrlIframe(iframe);
        } else {
            this.showSpread(spread_id);
        }
        return true;
    }

    includeSwipe(spread_id) {
        Message.sendMessage({ message: "INCLUDE_SWIPE" }, this.getContentWindow(spread_id));
    }

    getElement(spread_id) {
        return $("#" + spread_id);
    }

    getContentWindow(spread_id) {
        try {
            // return $('#spread_'+spread_id+' iframe').get(0).contentWindow;
            return $("#" + spread_id + " iframe").get(0).contentWindow;
        } catch (e) {
            console.warn("MAGLR ERROR: [getContentWindow]", e);
        }
    }

    showSpread(spread_id) {
        if (this.spreads.has(spread_id)) {
            let message = {
                message: "SHOW",
                spread_id: spread_id,
                extra_args: this.extra_args,
                disabledCookies: this.disabledCookies,
            };
            console.debug("< showSpread : " + spread_id);
            Message.sendMessage(message, this.getContentWindow(spread_id));
            let spreadContainer = this.spreads.get(spread_id);
            if (
                spreadContainer.data("spreadType") === 2 &&
                spreadContainer.data("version") < 10 &&
                spreadContainer.data("version") !== ""
            ) {
                console.log(`Dont add shown for ${spread_id}`);
            } else {
                spreadContainer.addClass("shown");
            }
            return true;
        }
    }

    spreadReady(spread_id, currentSpreadId) {
        if (this.spreads.has(spread_id)) {
            let spreadContainer = this.spreads.get(spread_id);
            if (
                spreadContainer.data("spreadType") === 2 &&
                spreadContainer.data("version") < 10 &&
                spread_id === currentSpreadId
            ) {
                spreadContainer.addClass("shown");
            }
        }
    }

    startSpread(spread_id) {
        if (this.spreads.has(spread_id)) {
            this._sendStart(spread_id);
            return true; //also render interface
        }
    }

    _sendStart(spread_id) {
        console.debug("< startSpread : " + spread_id);
        let spread = this.spreads.get(spread_id);
        if (spread.hasClass("shown")) {
            Message.sendMessage({ message: "START", spread_id: spread_id }, this.getContentWindow(spread_id));
            spread.addClass("started current-spread").removeClass("stopped");
            if ("ontouchstart" in window) {
                this.includeSwipe(spread_id);
            }
        }
    }

    stopSpread(spread_id) {
        if (this.spreads.has(spread_id)) {
            Message.sendMessage({ message: "STOP", spread_id: spread_id }, this.getContentWindow(spread_id));
            this.spreads.get(spread_id).removeClass("current-spread started").addClass("stopped");
        }
        return this;
    }
    pauseSpread() {
        return false;
    }

    destroySpread(spread_id) {
        if (this.spreads.has(spread_id)) {
            console.debug("< destroySpread : " + spread_id);
            this.spreads.delete(spread_id);
            $("#" + spread_id).html("");
            return true;
        }
        return false;
    }

    setCookieConsented(consented) {
        //TODO dit nog verder aanlsuiten
        this.disabledCookies = !consented;
        this.spreads.forEach((spread, spread_id) => {
            Message.sendMessage({ message: "COOKIECONCENTED", consented: consented }, this.getContentWindow(spread_id));
        });
    }
}
